import { render, staticRenderFns } from "./AccountRequest.vue?vue&type=template&id=46728e4e&scoped=true&"
import script from "./AccountRequest.vue?vue&type=script&lang=js&"
export * from "./AccountRequest.vue?vue&type=script&lang=js&"
import style0 from "./AccountRequest.vue?vue&type=style&index=0&id=46728e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46728e4e",
  null
  
)

export default component.exports